import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Badge } from '../ui/badge';
import { Globe, Plus } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const LanguagesTab = ({ languages, getAuthHeaders, onRefresh }) => {
  const [newLanguage, setNewLanguage] = useState({ code: '', name: '' });

  const handleAddLanguage = async () => {
    if (!newLanguage.code || !newLanguage.name) {
      toast.error('Please fill in both code and name');
      return;
    }
    
    try {
      const response = await fetch(`${API_URL}/api/settings/languages`, {
        method: 'POST',
        headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ ...newLanguage, is_active: true })
      });
      
      if (response.ok) {
        toast.success('Language added');
        setNewLanguage({ code: '', name: '' });
        onRefresh();
      }
    } catch (error) {
      toast.error('Failed to add language');
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Globe className="h-5 w-5" />
          Supported Languages
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-2 mb-6">
          {languages.map((lang) => (
            <Badge key={lang.code} variant="secondary" className="py-1 px-3">
              {lang.name} ({lang.code.toUpperCase()})
            </Badge>
          ))}
        </div>
        
        <div className="border-t pt-4">
          <h4 className="text-sm font-medium mb-3">Add New Language</h4>
          <div className="flex gap-2">
            <div className="flex-1">
              <Label className="sr-only">Code</Label>
              <Input
                placeholder="Language code (e.g., es)"
                value={newLanguage.code}
                onChange={(e) => setNewLanguage({ ...newLanguage, code: e.target.value.toLowerCase() })}
              />
            </div>
            <div className="flex-1">
              <Label className="sr-only">Name</Label>
              <Input
                placeholder="Language name"
                value={newLanguage.name}
                onChange={(e) => setNewLanguage({ ...newLanguage, name: e.target.value })}
              />
            </div>
            <Button onClick={handleAddLanguage}>
              <Plus className="h-4 w-4 mr-1" />
              Add
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default LanguagesTab;
